// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/single.scss
// module id = 55
// module chunks = 5